import { Component } from '@angular/core';
import { DurationRangeService } from '@app-core/services/duration-range/duration-range.service';

@Component({
  selector: 'app-new-home',
  templateUrl: './new-home.component.html',
  styleUrls: ['./new-home.component.scss'],
})
export class NewHomeComponent {
  constructor(public durationService: DurationRangeService) {}
}
